const sortDevicesByStatus = (devicesArray) => devicesArray.sort((a, b) => (a.status - b.status))

export default sortDevicesByStatus
